import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import { useSettingsTabs } from 'hooks';
import { NavigationButton } from 'components/elements/navigation';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function SettingsButtonTabs({ onSelectTab }) {
  const classes = useStyles();
  const { data: tabs } = useSettingsTabs();

  const ButtonTabs = () =>
    tabs.map(({ link, label }) => <NavigationButton classes={classes.tabButton} key={link} link={link} label={label} isSettingsNavigation onClick={onSelectTab} />);

  return (
    <div className={classes.buttonTabs}>
      <ButtonTabs />
    </div>
  );
}

SettingsButtonTabs.propTypes = {
  onSelectTab: PropTypes.func,
};

SettingsButtonTabs.defaultProps = {
  onSelectTab: () => {},
};

export default SettingsButtonTabs;
